import React from 'react'
import { StyledExternalLink } from './Link.styles'

type ExternalLinkProps = {
  text: string | JSX.Element
  href: string
  openInNewTab: boolean
  underline?: boolean
}

export const ExternalLink = ({
  text,
  href,
  openInNewTab,
  underline,
}: ExternalLinkProps): JSX.Element => (
  <StyledExternalLink
    href={href}
    rel={openInNewTab ? 'noreferrer' : undefined}
    target={openInNewTab ? '_blank' : undefined}
    $underline={underline}
  >
    {text}
  </StyledExternalLink>
)

ExternalLink.defaultProps = {
  openInNewTab: true,
}
